import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { PulseLoader } from "react-spinners";
import Form from 'react-bootstrap/Form';


import LoadingOverlay from '../../components/loading-ovelay/loading-overlay';
import './approvePanelPowerpoint.styles.scss';

//redux
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectPPTDocumentDetails, selectIsLoadingDocument } from "../../redux/tasks/task-selector";


const ApprovePanelPowerpoint = ({ pptDocument, isLoadingDocument, submitAction, show, setShowModal, actionType, taskName }) => {

    // Keep a local version of the DocArray to keep track of local comments
    const [commentText, setCommentText] = useState("");

    //modal controls
    const handleClose = () => {
        setShowModal()
    }

    const getSlidePreviews = (slideList) => {
        return (
            slideList.map(img => {
                return (
                    <div class="holder">
                        <img src={img} key={img.slice(-10)} class="pptx-table-body-img" alt="" />
                        <div class="tip"><img src={img} class="large-image" alt="" /></div>
                    </div>
                )
            })
        );
    }

    const getButton = () => (
        actionType === "Approve Task" ? <button className='modal-button primary-button' value='approve-action-panel' onClick={() => submitAction(commentText)} variant="outline-success">Approve</button>

        : <button className='modal-button primary-button' value='decline-action-panel' onClick={() => submitAction(commentText)} variant="outline-danger">Decline</button>
    )

    return (
        <div className='document-viewer-container'>
            <Modal show={show} onHide={handleClose} dialogClassName = 'pptx-action-panel' size = 'xl' centered className = 'pptx-action-panel'>
                <Modal.Header className="pptx-action-panel-modal-header">
                    <Modal.Title className="pptx-action-panel-modal-title">{taskName}</Modal.Title>
                    <button className="modal-close-btn" onClick={handleClose}></button>
                </Modal.Header>
                <div className="select-member-divider-line"></div>
                <Modal.Body className="pptx-approve-body">
                <LoadingOverlay area='tasks-action-panel-area'/>
                <br></br>
                { isLoadingDocument ? 
                        <div style = {{'padding' : '30px 100px', 'textAlign' : 'center'}} > <PulseLoader /> </div>  
                    :
                        <Form>
                            <table>
                                <tr className = 'pptx-action-panel-header'>
                                    <th className = 'text-font-styling pptx-action-panel-title' width="17%">ASSIGNED CONTENT</th>
                                    <th className = 'text-font-styling pptx-action-panel-title' width="17%">CHANGED CONTENT</th>
                                    <th className = 'text-font-styling pptx-action-panel-title' width="25%">FINAL COMMENT (OPTIONAL)</th>
                                </tr>
                                <tr className="pptx-table-row">
                                    {/* Assigned Content */}
                                    <td className = 'pptx-approve-table-body-cell'>
                                        {getSlidePreviews(pptDocument.assignedSlides)}
                                    </td>

                                    {/* Changed Content */}
                                    <td className = 'pptx-approve-table-body-cell'>
                                    {
                                        pptDocument.changedSlides.length > 0 ?
                                            getSlidePreviews(pptDocument.changedSlides)
                                        :
                                            <div class="no-changed-content">&lt;No Changed Content&gt;</div>
                                    }
                                    </td>

                                    {/* Final Comment Field */}
                                    <th className = 'pptx-approve-table-body-cell'>
                                        <Form.Group>
                                            <Form.Control as="textarea" rows="1" value={commentText} onChange={(e) => { setCommentText(e.target.value) }} placeholder="Enter comment" />
                                        </Form.Group>
                                    </th>
                                </tr>
                            </table>
                            <br></br>
                            <div className='pptx-approve-footer'>
                                <button className="modal-button tertiary-button" onClick={handleClose}>Go Back</button>
                                {getButton()}
                            </div>
                        </Form>
                }
                </Modal.Body>
                <Modal.Footer></Modal.Footer> {/*This empty footer is to ensure that the bottom border styling is applied and not covered up by loading overlays*/}
            </Modal>
        </div>
    );
};

const mapState = createStructuredSelector({
    pptDocument: selectPPTDocumentDetails,
    isLoadingDocument: selectIsLoadingDocument
})

export default connect(mapState, null)(ApprovePanelPowerpoint);
